<div class="govuk-width-container">
  <!-- (searchTerm)="search($event)" - re-enable if search comes back -->
  <gb-ui-header
      [imageDetail]="imageDetail"
      [showSearch]="false"
      [navLinks]="[]">
  </gb-ui-header>
</div>
